import { useTheme } from '@emotion/react';
import { Grid, Typography, Box, Divider, useMediaQuery, Checkbox } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';
import { TABLET_BREAKPOINT } from '../../Constants/constant';
import { getSplitName } from '../../Utils/Helpers/stringHelper';
import PrintIcon from '@mui/icons-material/Print';
import { useRef } from 'react';
import React from 'react';
import ReactToPrint from 'react-to-print/lib';
import SummaryToPrint from './summaryToPrint';
import { useApplicationContext } from '../../Context/applicationContext';
import { useFormContext } from 'react-hook-form';
import KenButton from '../KenButton';
import KenAccordion from '../KenAccordion';
import DocumentUpload from '../KenApplication/documentUpload';
import KenFieldContent from '../KenApplicationForm/Components/KenStepperContent/Components/KenFieldContent';
import { getDocumentByDocId } from '../../Utils/apiServices';
import KenLoader from '../KenLoader';
import sampleImg from "../../Assets/Images/altimage.png"

const useStyles = makeStyles((theme) => ({
  formContainer: {
    height: 'calc(100% - 16px)',
    paddingTop: theme.spacing(7.125),
    overflow: 'auto',
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      paddingTop: theme.spacing(3),
    },
  },
  stepLabel: {
    color: theme.palette.primary.main,
    fontWeight: 600,
  },

  sectionLabel: {
    fontWeight: 400,
  },
  sectionSubLabel: {
    color: '#7A869A',
    fontWeight: 400,
  },
  footerContainer: {
    position: 'absolute',
    bottom: '0px',
    padding: '16px',
    paddingRight: '223px',
    minHeight: 76,
    // height: "100px",
    left: '0px',
    right: '0px',
    overflow: 'hidden',
    background: '#FFFFFF',
    boxShadow: '10px 0px 20px rgba(0, 0, 0, 0.04), 2px 0px 6px rgba(0, 0, 0, 0.04), 0px 0px 1px rgba(0, 0, 0, 0.04)',
    // backgroundColor: "blue",
  },
  container: {
    position: 'absolute',
    top: '270px',
    bottom: '0px',
    left: '0px',
    right: '0px',
  },
  paymentContainer: {
    padding: '16px 223px',
  },
  fieldNameValue: {
    wordBreak: 'break-word',
    fontWeight: 400,
  },
  fieldName: {
    color: '#7A869A',
  },
  fieldValue: {
    color: '#061938',
  },
  fieldContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      flexDirection: 'column',
      'align-items': 'flex-start',
      'justify-content': 'flex-start',
      'max-width': '100%',
      display: 'flex',
      width: '100%',
      'padding-top': '0 !important',
    },
  },
  fieldKeyContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      width: '40%',
      'font-style': 'normal',
      'font-weight': '400',
      'font-size': '16px',
      'line-height': '150%',
      'text-transform': 'capitalize',
      color: '#7A869A',
    },
  },
  fieldValueContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      width: '60%',
      'font-style': 'normal',
      'font-weight': '400',
      'font-size': '16px',
      'line-height': '150%',
      color: '#061938',
    },
  },
  divider: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      margin: '5px auto 16px 0',
    },
  },
  dividerContainer: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      margin: '5px',
    },
  },
  dividerWrapper: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      margin: '0px',
      paddingTop: '0 !important',
    },
  },
  imgProfile: {
    border: '1px solid #ddd',
    borderRadius: '4px',
    padding: '5px',
    width: '150px',
  },
  heading: {
    [theme.breakpoints.down(TABLET_BREAKPOINT)]: {
      display: 'none',
    },
  },
}));

const KenSummary = React.forwardRef((props, ref) => {
  const { formJson, data, applicationState, saveForm } = props;
  const { applicationDispatch } = useApplicationContext();
  const { getValues, reset } = useFormContext();
  const classes = useStyles();
  const theme = useTheme();
  const isMobileScreen = useMediaQuery(theme.breakpoints.down(TABLET_BREAKPOINT));
  const applicationStatus = applicationState?.applicationData?.application?.applicationStatus;
  const isApplicationIncomplete = applicationStatus === 'Incomplete' || applicationStatus === 'Fee Paid';
  const formDeclared = applicationState?.declaration;
  const defaultCheckboxState = isApplicationIncomplete ? formDeclared : true;
  const hasNoAttachements = applicationState?.documents?.length === 0;

  const [accordionChange, setAccordionChange] = useState();
  const handleAccordion = (key) => {
    setAccordionChange(key);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // applicationState.formOptions;
  const checkFormOptions = (value, formArray) => {
    let combinedValues = [];
    const formArrayKeys = Object.values(formArray);
    for (let i = 0; i < formArrayKeys.length; i++) {
      const element = formArrayKeys[i];
      if (Array.isArray(element)) {
        combinedValues.push(...element);
      }
    }
    if (combinedValues.some((el) => el.value === value)) {
      return combinedValues.find((el) => el.value === value)?.label;
    } else if (value === 'true' || value === 'false') {
      return value === 'true' ? 'Yes' : 'No';
    } else {
      return value;
    }
  };

  const getFieldValue = (fieldName, formArray) => {
    try {
      const name = 'data[' + fieldName + ']';
      const keysArray = getSplitName(name, '', true) || [];
      console.log('keysArray', keysArray);
      let str = '';
      for (let i = 0; i < keysArray.length; i++) {
        const element = keysArray[i];
        if (i === 0) {
          str = element;
        } else {
          if (isNaN(element)) {
            str = `${str}["${element}"] && ${str}["${element}_select"] || ${str}["${element}"] && ${str}["${element}"]`;
          } else {
            str = `${str}[${element}] && ${str}[${element}]`;
          }
        }
      }
      return checkFormOptions(eval(str), formArray);
    } catch {
      console.error('error in eval');
    }
  };

  const LastDivider = () => {
    return (
      <Grid item xs={12} className={classes.dividerContainer}>
        <Divider className={classes.divider} />
      </Grid>
    );
  };

  // To enable edit feature in specified accordion
  const handleEdit = (section) => {
    applicationDispatch({
      type: 'updateSummary',
      payload: section,
    });
  };

  const getNestedData = (name, structure, fromData) => {
    const flatStructureData = structure.map((a) => {
      return { name: a?.name, label: a?.label };
    });
    let dataByName;
    if (/\d/.test(name)) {
      dataByName = getFieldValue(name);
    } else {
      dataByName = fromData[name] || [];
    }
    const allData = dataByName?.map((el) => {
      let obj = {};
      flatStructureData?.forEach((item) => {
        obj[item.label] = item.name.includes('semesterNumber') || item.name.includes('yearNumber') ? el[item?.name]?.replace(/\D/g, '') : el[item?.name];
      });
      return obj;
    });
    return allData;
  };

  const getNestedFieldRuleValidation = (currentField, currentKeyName, currentIndex) => {
    const getArrayFieldRule = currentField?.fieldsArray?.find((items) => {
      return items?.label === currentKeyName;
    });
    const arrayFieldRuleKeys = getArrayFieldRule?.rule?.condition?.scope ? getValues(`${currentField?.fieldId}.${currentIndex}.${getArrayFieldRule?.rule?.condition?.scope}`) : null;
    const arrayFieldRulevalue = getArrayFieldRule?.rule?.condition?.expectedValue ? getArrayFieldRule?.rule?.condition?.expectedValue : null;
    const isArrayRuleApplies = arrayFieldRuleKeys && arrayFieldRulevalue ? getRuleValuesConditions(getArrayFieldRule?.rule, arrayFieldRuleKeys) : false;
    return Object.keys(getArrayFieldRule?.rule ? getArrayFieldRule?.rule : {}).length === 0 || (Object.keys(getArrayFieldRule?.rule ? getArrayFieldRule?.rule : {}).length > 0 && isArrayRuleApplies);
  };

  const getRuleValuesConditions = (rule, value) => {
    const { expectedValue } = rule?.condition;
    if (typeof expectedValue === 'string') {
      return expectedValue === value;
    } else {
      return (
        (
          expectedValue?.filter((items) => {
            return items === value;
          }) || []
        ).length > 0
      );
    }
  };

  // To open accordion for the 1st element
  useEffect(() => {
    const array1 = formJson;
    let count = 0;
    for (let i = 0; i < array1.length; i++) {
      const element = array1[i].sections;
      for (let j = 0; j < element.length; j++) {
        count = count + 1;
        const element2 = element[j];
        if (element2.sectionVisible && count === 1) {
          handleAccordion(element2.sectionName);
        }
      }
    }
  }, [formJson]);

  const returnProperValue = (value) => {
    return value ? value : '-';
  };

  const getArrayValues = (values) => {
    let arrayValues = '';
    for (let i = 0; i < values.length; i++) {
      const element = values[i];
      if (i === values.length - 1) {
        arrayValues = arrayValues + `${element?.Program_Plan__r?.Name}`;
      } else {
        arrayValues = arrayValues + `${element?.Program_Plan__r?.Name},`;
      }
    }
    return arrayValues === '' ? '-' : arrayValues;
  };

  return (
    <Box ref={ref} paddingBottom={'68px'}>
      {isApplicationIncomplete && (
        <Typography align="left" marginBottom={theme.spacing(3)} className={classes.stepLabelSecondary} fontSize={isMobileScreen ? "14px" : "18px"}>
          Before clicking the submit button, please take a moment to review your application carefully. Ensure all information provided is accurate and complete. Once submitted, you may not be able to make changes.
        </Typography>
      )}
      <Typography align="left" marginBottom={isMobileScreen ? 0 : theme.spacing(3)} className={classes.stepLabel} fontSize="20px">
        Summary
      </Typography>
      <Box component={'div'} sx={{ pointerEvents: formDeclared ? 'none' : 'auto', opacity: formDeclared ? '0.8' : '1' }}>
        {formJson?.map((step) => {
          return step?.sections?.map((section, sectionIndex) => {
            const sectionShouldOnlyBeVisible = section.sectionVisible === true;
            const sectionId = section?.summaryName ? section?.summaryName : section?.sectionName;
            return section?.sectionId === 'documentUpload' ? (
              !hasNoAttachements ? (
                <KenAccordion
                  noedit
                  label={`${sectionId}`}
                  accordionVal={accordionChange}
                  expandedVal={accordionChange ? accordionChange === sectionId : false}
                  changeExpand={() => {
                    handleAccordion(sectionId);
                    handleEdit('');
                  }}
                >
                  <DocumentUpload  applicationState={applicationState} applicationDispatch={applicationDispatch} />
                </KenAccordion>
              ) : null
            ) : sectionShouldOnlyBeVisible ? (
              <>
                <KenAccordion
                  handleEdit={handleEdit}
                  applicationState={applicationState}
                  label={`${sectionId}`}
                  accordionVal={accordionChange}
                  expandedVal={accordionChange ? accordionChange === sectionId : false}
                  changeExpand={() => {
                    if (accordionChange !== sectionId) {
                      handleAccordion(sectionId);
                      handleEdit('');
                    }
                  }}
                >
                  <Grid container spacing={2}>
                    {section.fields.map((field) => {
                      const nestedFiledArray = field?.type === 'array' && getNestedData(field.name, field.fieldsArray, data);
                      const normalFields = getFieldValue(field.name, applicationState.formOptions);
                      const edit = applicationState.summaryEdit === sectionId;
                      const isRuleApplied = field?.rule?.effect === 'SHOW' ? getRuleValuesConditions(field?.rule, getValues(`${field?.rule?.condition?.scope}`)) : true;
                      const isRuleHided = field?.rule?.effect === 'HIDE' ? getRuleValuesConditions(field?.rule, getValues(`${field?.rule?.condition?.scope}`)) : false;
                      const grid = field?.ui?.gridType === 'fullRow' ? { lg: 12, md: 12, xs: 12 } : field?.ui?.grid;
                      return edit ? (
                        <KenFieldContent {...field} />
                      ) : field?.type === 'array' ? (
                        // For Array type fields
                        <Grid item container xs={12} md={12} spacing={3}>
                          <>
                            {nestedFiledArray.map((nestedField, nestedFieldIndex) => {
                              const validFieldArray = nestedField ? Object.keys(nestedField) : [];
                              return validFieldArray.map((keyName, keyIndex) => {
                                const isFieldValid = nestedField[keyName] !== null && keyName !== 'undefined';
                                const lastField = validFieldArray.length - 1 === keyIndex && nestedField.length - 1 !== nestedFieldIndex;
                                return isFieldValid && isRuleApplied && getNestedFieldRuleValidation(field, keyName, nestedFieldIndex) && nestedFieldIndex < field?.metaData?.maxLimit ? (
                                  <>
                                    <Grid item container xs={12} md={6} spacing={1} className={classes.fieldContainer}>
                                      <Grid item xs={12} sm={12} md={6} textAlign="left" className={classes.fieldKeyContainer}>
                                        <Typography className={`${classes.fieldName} ${classes.fieldNameValue}`} variant="h5">
                                          {keyName}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={12} sm={12} md={6} textAlign="left" className={classes.fieldValueContainer}>
                                        <Typography className={`${classes.fieldValue} ${classes.fieldNameValue}`} variant="h5">
                                          {returnProperValue(nestedField[keyName])}
                                        </Typography>
                                      </Grid>
                                    </Grid>
                                    {lastField || validFieldArray.length === 1 ? <LastDivider /> : null}
                                  </>
                                ) : null;
                              });
                            })}
                          </>
                        </Grid>
                      ) : field?.fieldId ? (
                        <>
                          {/* For Normal Fields */}
                          {normalFields && isRuleApplied && isRuleHided === false ? (
                            <Grid item container {...grid} spacing={2} className={classes.fieldContainer}>
                              <Grid item xs={12} sm={12} md={6} textAlign="left" className={classes.fieldKeyContainer}>
                                <Typography className={`${classes.fieldName} ${classes.fieldNameValue}`} variant="h5">
                                  {field?.label === 'Tracks' ? 'Program' : field?.label}
                                </Typography>
                              </Grid>
                              <Grid item xs={12} sm={12} md={6} textAlign="left" className={classes.fieldValueContainer}>
                                <Typography className={`${classes.fieldValue} ${classes.fieldNameValue}`} variant="h5">
                                  {field && (typeof normalFields === 'string' || typeof normalFields === 'number') ? (returnProperValue(normalFields) === 'nulltestnoncore@gmail.com' ? '-' : returnProperValue(normalFields)) : getArrayValues(normalFields)}
                                </Typography>
                              </Grid>
                            </Grid>
                          ) : null}
                          {field?.ui?.divider && <LastDivider />}
                        </>
                      ) : (
                        <>
                          {/* For Country Type of fields */}
                          {isRuleApplied && isRuleHided === false
                            ? field?.options.map((el) => {
                                const names = el.fieldId === 'Qualification_Country__c' ? 'applicant[Qualification_Country__c]' : `${field.name}${el.fieldId}`;
                                const addressTypeFields = getFieldValue(names, applicationState.formOptions);
                                return (
                                  <>
                                    {addressTypeFields ? (
                                      <Grid item container {...grid} spacing={2} className={classes.fieldContainer}>
                                        <Grid item xs={12} sm={12} md={6} textAlign="left" className={classes.fieldKeyContainer}>
                                          <Typography className={`${classes.fieldName} ${classes.fieldNameValue}`} variant="h5">
                                            {el?.label}
                                          </Typography>
                                        </Grid>
                                        <Grid item xs={12} sm={12} md={6} textAlign="left" className={classes.fieldValueContainer}>
                                          <Typography className={`${classes.fieldValue} ${classes.fieldNameValue}`} variant="h5">
                                            {returnProperValue(addressTypeFields)}
                                          </Typography>
                                        </Grid>
                                      </Grid>
                                    ) : null}
                                    {field?.ui?.divider && <LastDivider />}
                                  </>
                                );
                              })
                            : null}
                        </>
                      );
                    })}
                  </Grid>
                  {applicationState?.summaryEdit === accordionChange ? (
                    <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', marginTop: '20px', gap: '10px' }}>
                      <KenButton
                        buttonClass={classes.saveBtn}
                        variant="outlined"
                        type="button"
                        onClick={() => {
                          reset();
                          handleEdit('');
                        }}
                      >
                        Cancel
                      </KenButton>
                      <KenButton
                        buttonClass={classes.nextBtn}
                        variant="contained"
                        type="button"
                        onClick={() => {
                          saveForm();
                        }}
                      >
                        Save
                      </KenButton>
                    </Box>
                  ) : null}
                </KenAccordion>
              </>
            ) : null;
          });
        })}
      </Box>
      {applicationState.summaryEdit === '' && (
        <Box margin={'60px auto'} width={'100%'} display={'flex'} alignItems={'center'} gap={'10px'}>
          <Checkbox
            size="medium"
            checked={defaultCheckboxState}
            onChange={(e) => {
              applicationDispatch({
                type: 'declaration',
                payload: e.target.checked,
              });
            }}
          />
          <Typography fontWeight={500}>{'I hereby declare that the information is true'}</Typography>
        </Box>
      )}
    </Box>
  );
});

const KenSummaryStep = (props) => {
  const componentRef = useRef();
  const {applicationState} = useApplicationContext()
  const { getValues } = useFormContext();
  const [loader, setLoader] = useState(false)
  const [logo, setLogo] = useState(sampleImg)

  React.useEffect(() => {
    let attachments = applicationState.documents;
    if (attachments !== undefined && attachments.length > 0) {
      attachments = attachments.filter((item) =>
        item.title.toLowerCase().includes('passport')
      );
      if (attachments.length > 0) {
        let id = attachments[0]?.recordId || null;
        if (id) {
          setLoader(true);
          getDocumentByDocId(id)
            .then((res) => {
              if (res?.success && res?.data) {
                setLoader(false);
                if (res.data) {
                  setLogo(`data:image/png;base64,${res.data}`);
                }
              }
            })
            .catch((err) => {
              setLoader(false);
            });
        }
      }
    }
  }, [applicationState.documents]);

  return (
    <div>
      {loader && <KenLoader/>}
      <Box display={'flex'} justifyContent={'end'} alignItems={'center'} gap={'10px'}>
        <ReactToPrint pageStyle="size: 11.0in 8.5in; !important;" trigger={() => <PrintIcon />} content={() => componentRef.current} removeAfterPrint={false} copyStyles={true} />
      </Box>
      <KenSummary {...props} />
      {/* <SummaryToPrint ref={componentRef} getValues={getValues} image={logo} {...props} /> */}
      <div style={{ display: 'none' }}>
        <SummaryToPrint ref={componentRef} getValues={getValues} image={logo} {...props} />
      </div>
    </div>
  );
};

export default KenSummaryStep;
